module.exports = __webpack_public_path__ + "img/hzzxrm.a000fa37.png";